"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var levels = [
    'Advanced',
    'Basic',
    'Intermediate',
    'Overview',
    'Update'
];
exports.levels = levels;
//# sourceMappingURL=levels.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/library/dist/levels.js
// module id = 887
// module chunks = 0